import { useState } from "react";
import { useApp } from "../context/AppContext";
import { useAuth } from "../context/AuthContext";
import api, { apiError } from "../lib/api";
import { RupiahInput } from "./RupiahInput";
import { Button } from "./ui/button";
import { Lock, Wallet } from "lucide-react";
import { toast } from "sonner";

export function DailyBalanceGate({ children }) {
  const { balance, refreshBalance } = useApp();
  const { user } = useAuth();
  const [amount, setAmount] = useState(0);
  const [saving, setSaving] = useState(false);

  if (!user) return children;
  if (balance.exists) return children;

  const submit = async () => {
    setSaving(true);
    try {
      await api.post("/daily-balance", { amount });
      await refreshBalance();
      toast.success("Saldo awal tersimpan. Sistem terbuka.");
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="pointer-events-none blur-sm opacity-40">{children}</div>
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/70 backdrop-blur-sm p-4">
        <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden"
          data-testid="daily-balance-gate">
          <div className="bg-slate-900 px-6 py-5 flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-orange-500 flex items-center justify-center">
              <Lock className="h-5 w-5 text-white" />
            </div>
            <div>
              <h2 className="text-white text-lg font-bold font-display">Saldo Awal Harian</h2>
              <p className="text-slate-400 text-xs">Sistem terkunci hingga saldo awal diisi</p>
            </div>
          </div>
          <div className="p-6 space-y-4">
            <p className="text-sm text-slate-600 flex items-start gap-2">
              <Wallet className="h-4 w-4 mt-0.5 text-orange-500 shrink-0" />
              Masukkan saldo kas awal untuk hari ini. Seluruh menu terkunci sampai diisi.
            </p>
            <RupiahInput value={amount} onChange={setAmount}
              data-testid="daily-balance-modal-input" placeholder="0" autoFocus />
            <Button onClick={submit} disabled={saving}
              className="w-full bg-orange-500 hover:bg-orange-600 h-11 text-base font-semibold"
              data-testid="daily-balance-submit-button">
              {saving ? "Menyimpan..." : "Buka Sistem"}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
